// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df62a9ad","389":"d6f630cd","455":"58fce3a8","488":"1446b851","977":"67bbc2f9"}[chunkId] + ".chunk.js";
};